import sassConstants from '@/constants/sass'

export default {
  TOP_POSITION: sassConstants.topPosition,
  CENTER_POSITION: sassConstants.centerPosition,
  BOTTOM_POSITION: sassConstants.bottomPosition,
}
